import React from 'react'
import AnimatedPage from '../Animation/AnimatedPage'

export default function BannerImage() {
    return (
        <div className='h-screen flex items-center w-[65%] 2xl:w-[70%] xl:pr-0 pr-7'>
            <img loading='lazy' decoding='async' src="/images/ARCM_login_banner.png" alt="Banner-Img" 
                className='2xl:w-[90%] w-full h-fit' />
                
        </div>
    )
}
